import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { M01SplashScreen } from './screens/M01SplashScreen';
import { M02LoginScreen } from './screens/M02LoginScreen';
import { M03HomeScreen } from './screens/M03HomeScreen';
import { M04ProductListScreen } from './screens/M04ProductListScreen';
import { M05ProductDetailScreen } from './screens/M05ProductDetailScreen';
import { M06InputCustomerScreen } from './screens/M06InputCustomerScreen';
import { M07ResultScreen } from './screens/M07ResultScreen';
import { M08CompareScreen } from './screens/M08CompareScreen';
import { M09PdfScreen } from './screens/M09PdfScreen';
import { M10SaveCustomerScreen } from './screens/M10SaveCustomerScreen';
import { M11HistoryScreen } from './screens/M11HistoryScreen';
import { M12ProfileScreen } from './screens/M12ProfileScreen';
import { AppBar, BottomNav } from './components';
import type { RootStackParamList } from './types/navigation';
import { APP_BAR_HEIGHT, BOTTOM_NAV_HEIGHT } from './theme';

export type { RootStackParamList } from './types/navigation';

const Stack = createStackNavigator<RootStackParamList>();

export const AppNavigator: React.FC = () => {
  const [currentRoute, setCurrentRoute] = useState<string>('M01SplashScreen');

  const showHeader = currentRoute !== 'M01SplashScreen' && currentRoute !== 'M02LoginScreen';
  const showFooter = currentRoute !== 'M01SplashScreen' && currentRoute !== 'M02LoginScreen';

  return (
    <NavigationContainer
      onStateChange={(state) => {
        if (state) {
          let route: any = state.routes[state.index];
          while (route.state) {
            const nestedIndex = route.state.index ?? 0;
            route = route.state.routes[nestedIndex];
          }
          setCurrentRoute(route.name);
        }
      }}
    >
      {/* Shell: AppBar (absolute top) + flex content + BottomNav (fixed/absolute bottom) */}
      <View style={styles.shell}>
        <AppBar />

        <View
          style={[
            styles.content,
            {
              paddingTop: showHeader ? APP_BAR_HEIGHT : 0,
              paddingBottom: showFooter ? BOTTOM_NAV_HEIGHT : 0,
            },
          ]}
        >
          <Stack.Navigator
            initialRouteName="M01SplashScreen"
            screenOptions={{
              headerShown: false,
              cardStyle: { backgroundColor: '#f5f7fa' },
            }}
          >
            <Stack.Screen name="M01SplashScreen"        component={M01SplashScreen} />
            <Stack.Screen name="M02LoginScreen"         component={M02LoginScreen} />
            <Stack.Screen name="M03HomeScreen"          component={M03HomeScreen} />
            <Stack.Screen name="M04ProductListScreen"   component={M04ProductListScreen} />
            <Stack.Screen name="M05ProductDetailScreen" component={M05ProductDetailScreen} />
            <Stack.Screen name="M06InputCustomerScreen" component={M06InputCustomerScreen} />
            <Stack.Screen name="M07ResultScreen"        component={M07ResultScreen} />
            <Stack.Screen name="M08CompareScreen"       component={M08CompareScreen} />
            <Stack.Screen name="M09PdfScreen"          component={M09PdfScreen} />
            <Stack.Screen name="M10SaveCustomerScreen"  component={M10SaveCustomerScreen} />
            <Stack.Screen name="M11HistoryScreen"       component={M11HistoryScreen} />
            <Stack.Screen name="M12ProfileScreen"       component={M12ProfileScreen} />
          </Stack.Navigator>
        </View>

        <BottomNav />
      </View>
    </NavigationContainer>
  );
};

const styles = StyleSheet.create({
  shell: { flex: 1, flexDirection: 'column', overflow: 'hidden' },
  content: { flex: 1, minHeight: 0 },
});

